import api from "../config/api";

export const getActiveAcquirers = async () => {
  let acquirersActives = [];
  try {
    let acquirerResponse = await api.get("Adquirentes/ListarAtivos");
    if (acquirerResponse.data.length > 0) {
      acquirersActives = acquirerResponse.data;
    }
  } catch (error) {
    acquirersActives = "Erro ao carregar adquirentes ativos.";
  }
  return acquirersActives;
};

export const getAcquirers = async (filter) => {

  let ListAcquirers = [];
  let url = `Adquirentes/ObterTodos?numeroPagina=${filter.numeroPagina}&itensPorPagina=${filter.itensPorPagina}&`;

  if( filter.nomeFantasia !== null ||	
      filter.inscricao !== null ||	
      filter.exigePreCadastro !== null ||	
      filter.possuiCheckoutInterno !== null ||	
      filter.possuiCheckoutExterno !== null ||	
      filter.ativo !== null ||	
      filter.sigla !== null ||	
      filter.campoOrdenacao !== null ||	
      filter.sentidoOrdenacao !== null ) {

    if(filter.nomeFantasia	!== null)
      url = `${url}NomeFantasia=${filter.nomeFantasia}&`;
    if(filter.inscricao	!== null)
      url = `${url}Inscricao=${filter.inscricao}&`;
    if(filter.exigePreCadastro	!== null)
      url = `${url}ExigePreCadastro=${filter.exigePreCadastro}&`;
    if(filter.possuiCheckoutInterno	!== null)
      url = `${url}PossuiCheckoutInterno=${filter.possuiCheckoutInterno}&`;
    if(filter.possuiCheckoutExterno	!== null)
      url = `${url}PossuiCheckoutExterno=${filter.possuiCheckoutExterno}&`;
    if(filter.ativo	!== null)
      url = `${url}Ativo=${filter.ativo}&`;
    if(filter.sigla	!== null)
      url = `${url}Aigla=${filter.sigla}&`;
    if(filter.campoOrdenacao	!== null)
      url = `${url}CampoOrdenacao=${filter.campoOrdenacao}&`;
    if(filter.sentidoOrdenacao!== null)
      url = `${url}SentidoOrdenacao=${filter.sentidoOrdenacao}&`;

    }
    
  url = url.substring(0, url.length - 1);
  
  try {
    let acquirerResponse = await api.get(url);
    if (acquirerResponse.data.List.length > 0) {
      ListAcquirers = acquirerResponse.data.List;
    }
  } catch (error) {
    ListAcquirers = "Erro ao carregar adquirentes ativos.";
  }
  return ListAcquirers;
};

export const editAcquirer = async (Acquirer) => {
  let returnAcquirer;
  try {
    returnAcquirer = await api.put("Adquirentes/Editar", { ...Acquirer } );

  } catch (error) {
    returnAcquirer = "Erro ao atualizar adquirentes.";
  }
  return returnAcquirer;
};

